module.exports = __webpack_public_path__ + "img/13.4c7e29f9.png";